module.exports = __webpack_public_path__ + "img/boky_08_zluta.f56147fa.png";